<!-- Separar en un componente @TODO -->
<article class="banner_vehicle my-5">
    <div class="banner_vehicle-details">
        <img src="./assets/img/svg/Moto.svg" alt="">
        <h2>Detalles de tu moto</h2>
    </div>

    <div class="banner_vehicle-info">
        <p>
            Placa:
            <span>{{ dataVehicle.Placa }}</span>
        </p>
        <p>
            Modelo:
            <span>{{ dataVehicle.Modelo }}</span>
        </p>
        <p>
            Marca:
            <span>{{ dataVehicle.Marca }}</span>
        </p>
    </div>
</article>